/**
 * 金钱转换 - 分转元
 * @param {Number} fen 分
 * @param {Boolean} nodot 保留小数位末尾的0，如果为true返回的将会是String<Number>
 */
export function fen2yuan(fen, nodot = true) {
  let yuan = (fen / 100).toFixed(2)
  if (nodot) {
    return yuan
  } else {
    return yuan - 0
  }
}

/**
 * 过滤对象字段名
 * @param {Object} target
 * @param {Object} rule
 * filterObjKeys(this.form, ['item_name', 'pict_url']) // 过滤
 * filterObjKeys(this.form, ['item_name', 'pict_url'], (tKey, rKey) => tKey!=rKey) // 排除
 */
export function filterObjKeys(target, rule, fn) {
  var keys = Object.keys(target).filter((targetKey) => { 
    return rule.some((ruleKey) => {
      return  (fn&&fn(targetKey, ruleKey)) || (targetKey == ruleKey)
    })
  })
  var temp = {};
  keys.forEach((v) => {
    temp[v] = target[v]
  })
  return temp
}
/**
 * 金钱转换 - 元转分
 * @param {Number} yuan 元
 */
export function yuan2fen(yuan) {
  return (yuan * 100).toFixed(0) - 0
}

/**
 * 字符串字节长度
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

/**
 * 清空数组中无内容的元素
 * @param {Array} actual 数组
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * 对象格式化为URL参数
 * @param {Object} json 参数对象
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * URL参数格式化为对象
 * @param {String} url 
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
  )
}

/**
 * 数组去重
 * @param {Array} arr 数组
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * 判断字符串是否是外链
 * @param {String} path 路径连接
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 去抖函数
 * @param {Function} func 延迟执行函数
 * @param {Number} wait 延迟时间
 * @param {*} immediate 
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 判断移动设备
 * @returns {Boolean}
 */
export function isMobile() {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    return true
  } else {
    return false
  }
}


/**
 * 过滤对象中不需要的字段，并返回一个新的对象
 * @param {Object} obj 原始对象，单层对象
 * @param {Array|String} keys 需要删除的字段
 * @param {Boolean} [keep=false] true：删除keys未声明的字段；false：删除keys声明的字段
 */
export function limitObject(obj, keys, keep = false) {
  if (!keys) return ({ ...obj })

  if (typeof keys === 'string') {
    keys = [keys]
  }

  if (keep) {
    let newobj = {}
    keys.forEach((key) => {
      let val = obj[key]
      if (val === undefined) val = null
      newobj[key] = val
    })
    obj = newobj
  } else {
    obj = { ...obj }
    keys.forEach((key) => {
      delete obj[key]
    })
  }

  return obj
}


/**
 * 过滤对象为空''字段，并返回一个新的对象
 * @param {Object} obj 原始对象，单层对象
 */
export function filterEmtry(obj) {
  var newObj = { ...obj }
  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === '') {
      delete newObj[key]
    }
  })
  return newObj
}

/**
 * 过滤对象为null字段，并返回一个新的对象
 * @param {Object} obj 原始对象，单层对象
 */
export function filterNull(obj) {
  var newObj = { ...obj }
  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === null) {
      delete newObj[key]
    }
  })
  return newObj
}

import { Message } from 'element-ui'
/**
 * 接口返回提示框
 * 
 * @param {Object} data 接口返回的data信息
 * @param {String} successMessage data.error_code == 0时显示的信息，不填写则不会显示成功信息
 */
export function requestResultMessage(data, successMessage) {
  if (data.error_code == 0) {
    successMessage && Message.success(successMessage)
  }
  else {
    Message.error(data.error_message)
  }
  return data.error_code == 0
}

/**
 * 将 '' | [] 转成null
 * 一般用于重置发送到服务器的空字段
 * @param {Object} obj
 */
export function emtry2null(obj) {
  var newObj = {...obj}
  for(let key in newObj) {
    let item = newObj[key]
    if(typeof item === 'string' && item === '') {
      newObj[key] = null
    }
    else if(Array.isArray(item) && !item.length) {
      newObj[key] = null
    }
  }
  return newObj
}

/**
 * 数据比较
 *  
 * @param   {String}  source   源数据
 * @param   {String}  new      新数据
 * @return  {String}  
 */
export function dataDiff(source, newData, exclude=[]) {
  var diff = {};
  // 取出source的key
  Object.keys(source).forEach((key) => {

    if(exclude.includes(key)) {
      diff[key] = newData[key]
    }
    else {
      // newData中有相同的key
      if (Object.keys(newData).includes(key)) {
        // 值是否不相等
        if (source[key] !== newData[key]) {
          if (JSON.stringify(source[key]) !== JSON.stringify(newData[key])) {
            diff[key] = newData[key]
          }
        }
      }
    }
  })
  return diff


}


